import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useSessionExpired } from '@/hooks/use-session-expired';
import { loginUrl } from '@/lib/login-navigation';

/** Mounted only by the authenticated admin shell; public pages have no shell. */
export function SessionExpiredDialog() {
  const expired = useSessionExpired();
  return (
    <Dialog open={expired} onOpenChange={() => undefined} analyticsFeatureId="surface.components.session-expired-dialog.dialog-1">
      <DialogContent role="alertdialog" showCloseButton={false} elevated>
        <DialogHeader>
          <DialogTitle>Session ended</DialogTitle>
          <DialogDescription>Your session has ended. Sign in again to continue.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => { window.location.href = loginUrl(window.location.pathname + window.location.search); }}>
            Sign in
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
